import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { PermissionsContext } from "../utils/PermissionsContext";
import { ModulesContext, isModuleActive } from "../utils/ModulesContext";

/**
 * Blocks access by permission and optionally by module active status.
 *
 * @param {React.ReactElement} element      - The route component to render.
 * @param {string} requiredPermission       - Permission string required to access this route.
 * @param {number} [moduleId]               - Optional module ID; redirects to /home if inactive.
 */
const ProtectedRoute = ({ element, requiredPermission, moduleId }) => {
  const permissions = useContext(PermissionsContext);
  const { modules } = useContext(ModulesContext);

  if (!permissions.includes(requiredPermission)) {
    return <Navigate to="/home" replace />;
  }

  if (moduleId !== undefined && !isModuleActive(modules, moduleId)) {
    return <Navigate to="/home" replace />;
  }

  return element;
};

export default ProtectedRoute;
